// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function PhoneIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="m27.796 19.808-5.889-2.64-.016-.007a1.999 1.999 0 0 0-1.896.175.984.984 0 0 0-.094.07L16.86 20c-1.928-.936-3.918-2.911-4.854-4.814l2.597-3.088c.025-.032.05-.063.072-.097a2 2 0 0 0 .165-1.882v-.015l-2.646-5.899a2 2 0 0 0-2.078-1.19A7.032 7.032 0 0 0 4 10c0 9.925 8.075 18 18 18a7.032 7.032 0 0 0 6.985-6.115 2 2 0 0 0-1.189-2.078ZM22 26A16.017 16.017 0 0 1 6 10a5.025 5.025 0 0 1 4.359-5v.015l2.625 5.875-2.584 3.092a.77.77 0 0 0-.071.097 2 2 0 0 0-.125 1.962c1.132 2.317 3.466 4.633 5.807 5.764a2 2 0 0 0 1.969-.142c.032-.022.063-.046.093-.07L21.11 19l5.875 2.631H27A5.026 5.026 0 0 1 22 26Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
